import React from 'react';
import translations from '../utils/translations';

const NetlistEditor = ({ 
  netlistFirstLine, 
  netlistContent, 
  setNetlistContent, 
  handleSave,
  current_locale = 'en',
  isRTL = false
}) => {
  // Get translations based on locale
  const t = translations[current_locale] || translations['en'];
  return (
    <div style={{ 
      height: '100%', 
      display: 'flex', 
      flexDirection: 'column', 
      overflow: 'auto',
      maxHeight: '100%',
      direction: isRTL ? 'rtl' : 'ltr',
      textAlign: isRTL ? 'right' : 'left'
    }}>
      
      {/* First line (read-only) - Now with a fixed position to ensure it's always visible */}
      <div style={{
        display: 'flex',
        marginBottom: '8px',
        position: 'relative',
        zIndex: 5, // Ensure it stays above the textarea
        flexShrink: 0 // Prevent it from shrinking
      }}>
        <input
          type="text"
          readOnly
          value={netlistFirstLine}
          style={{
            width: '100%',
            padding: '8px 15px',
            boxSizing: 'border-box',
            border: '1px solid #b8a88e',
            borderRadius: '6px',
            fontFamily: 'monospace',
            fontSize: '14px',
            backgroundColor: '#e8dcc7', /* Slightly darker than textarea to indicate read-only */
            color: '#5d4c3a',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            outline: 'none',
            cursor: 'default'
          }}
        />
      </div>
      
      {/* Netlist body (editable) */}
      <div style={{ position: 'relative', flex: 1, overflow: 'hidden', marginBottom: '0' }}>
        {/* Simple textarea with clean styling */}
        <textarea
          style={{
            width: '100%',
            height: '100%',
            padding: '15px',
            boxSizing: 'border-box',
            fontFamily: 'monospace',
            fontSize: '14px',
            lineHeight: '1.5',
            resize: 'none',
            border: '1px solid #b8a88e',
            borderRadius: '6px',
            outline: 'none',
            backgroundColor: '#f0e6d6',
            color: '#5d4c3a',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            overflowY: 'auto'
          }}
          value={netlistContent}
          onChange={(e) => {
            const newContent = e.target.value;
            setNetlistContent(newContent);
          }}
          placeholder={t.enterNetlistContent}
          spellCheck="false"
        />
      </div>
    </div>
  );
};

export default NetlistEditor;
